import { createSelector } from 'reselect';
import get from 'lodash/get';
import identity from 'lodash/identity';
import { RootState } from '../../../stores/types';

export default createSelector<RootState, RootState, string>(
  identity,
  (state) => get(state, 'analytics.gmvForm.region'),
);
